module.exports = __webpack_public_path__ + "static/media/tutor-id-3.64eda992.jpg";